const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * True when value is a usable auth user id (not empty / "undefined" string).
 * Guards API paths like `/api/subscriptions/current/:userId`.
 */
export function isValidUserId(value: string | null | undefined): value is string {
  if (typeof value !== "string") {
    return false;
  }
  const trimmed = value.trim();
  if (!trimmed || trimmed === "undefined" || trimmed === "null") {
    return false;
  }
  return UUID_RE.test(trimmed);
}
